// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDarInventoryIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDarInventoryIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDarInventoryIconOutlined = function DrrpDarInventoryIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDarInventoryIconOutlinedSvg
  }));
};

DrrpDarInventoryIconOutlined.displayName = 'DrrpDarInventoryIconOutlined';
export default React.forwardRef(DrrpDarInventoryIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDarInventoryIconOutlined.js
// module id = 2520
// module chunks = 0